module.exports = "https://health.dajiuxing.com.cn/img/assets/img/jg.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fjg.png
// module id = vAj9
// module chunks = 93